import type { ComponentProps } from "react";

type ButtonVariant = "primary" | "ghost" | "danger";

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:
    "font-semibold bg-rs-green text-rs-black hover:bg-rs-light-green disabled:bg-rs-jet disabled:text-[#6e7568] disabled:cursor-not-allowed",
  ghost:
    "font-normal bg-transparent text-rs-off-white border border-rs-jet-light hover:border-rs-green hover:text-rs-green",
  danger: "font-semibold bg-rs-red text-white hover:bg-[#f0776a]",
};

interface ButtonProps extends ComponentProps<"button"> {
  variant?: ButtonVariant;
}

export function Btn({ variant = "primary", className = "", ...props }: ButtonProps) {
  return (
    <button
      className={`inline-flex items-center gap-2 rounded-md px-5 py-[11px] ${VARIANT_CLASSES[variant]} ${className}`}
      {...props}
    />
  );
}
